/** @jsxImportSource @gasman/smush */

import './toolbar.css';
import newImage from '../icons/file-plus.svg';
import openImage from '../icons/folder-open.svg';
import saveImage from '../icons/save.svg';
import playImage from '../icons/play-circle.svg';
import stopImage from '../icons/stop-circle.svg';
import exportImage from '../icons/file-export.svg';
import exchangeImage from '../icons/exchange.svg';

import { Component } from '@gasman/smush';
import { save } from 'save-file';
import fileDialog from 'file-dialog';

class Toolbar extends Component {
    constructor(app) {
        super();
        this.app = app;
        this.song = null;

        let playStopAction = () => {
            if (this.app.player.isPlaying) {
                this.app.player.stop();
            } else if (this.song && !this.app.player.isActive) {
                this.app.player.playSong();
            }
        };

        this.playImage = <img src={playImage} alt="Play" />;
        this.playButton = (
            <button onclick={playStopAction} title="Play">
                {this.playImage}
            </button>
        );
        this.app.player.on('startPlaying', () => {
            this.playImage.src = stopImage;
            this.playImage.alt = 'Stop';
            this.playButton.title = 'Stop';
        });
        this.app.player.on('stopPlaying', () => {
            this.playImage.src = playImage;
            this.playImage.alt = 'Play';
            this.playButton.title = 'Play';
        });

        let openAction = () => {
            fileDialog().then((file) => {
                this.app.openSongFile(file[0]);
            });
        };

        let saveAction = () => {
            if (this.song) {
                save(this.song.asBlob(), 'song.rev');
            }
        };

        let showNewSongModal = () => {
            this.app.newSongModal.show();
        };

        let exportAction = () => {
            const formats = this.song.exportFormats;
            if (formats.length === 0) return;

            // TODO: If there are multiple formats, show a dialog to select one. For now, just use the first format.
            const format = formats[0];
            const exportData = this.song.exportToFormat(format);
            if (exportData.files) {
                for (const file of exportData.files) {
                    save(file.data, file.filename);
                }
            } else {
                save(exportData.data, exportData.filename);
            }
            return;
        };
        this.exportButton = (
            <button onclick={exportAction} title="Export">
                <img src={exportImage} alt="Export" />
            </button>
        );

        let convertAction = () => {
            if (this.song) {
                if (
                    confirm(
                        `Convert to ${this.song.convertTargetEngine} format? This will discard any data that cannot be converted.`,
                    )
                ) {
                    const { song: convertedSong, engine } =
                        this.song.convertToOtherEngine();
                    this.app.openSong(convertedSong, engine);
                }
            }
        };

        this.menuBar = (
            <div class="toolbar">
                <button onclick={showNewSongModal} title="New song">
                    <img src={newImage} alt="New song" />
                </button>
                <button onclick={openAction} title="Open">
                    <img src={openImage} alt="Open" />
                </button>
                <button onclick={saveAction} title="Save">
                    <img src={saveImage} alt="Save" />
                </button>
                {this.exportButton}
                <button onclick={convertAction} title="Convert to other engine">
                    <img src={exchangeImage} alt="Convert" />
                </button>
                {this.playButton}
            </div>
        );
    }

    render(container) {
        container.appendChild(this.menuBar);
    }

    bind(song) {
        this.song = song;
        if (this.song.exportFormats.length) {
            this.exportButton.disabled = false;
        } else {
            this.exportButton.disabled = true;
        }
    }
    unbind() {
        this.song = null;
    }
}

export { Toolbar };
